/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Paper,
  MuiThemeProvider,
  Button,
  useMediaQuery,
  Tooltip,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { actionTableMuiTheme } from "../table/table_styles";

import * as schoolDUCK from "../../../redux/ducks/school.duck";
import { setLoader } from "../../../redux/ducks/load.duck";
import { Add, Delete } from "@material-ui/icons";
import CustomTableFooter from "../../utils/CustomTableFooter";
import { setAlert } from "../../../redux/ducks/alert.duck";
import SpotlightDialog from "./components/SpotlightDialog";
import {
  getSpotlightsList,
  getSpotlight,
  deleteSpotlight,
} from "../../crud/api/spotlight.crud";
import { formatDate } from "../../utils/dates";

const Spotlight = ({ settingLoader, handleAlert }) => {
  const isDesktop = useMediaQuery("(min-width: 960px)");
  const [dialog, setDialog] = useState("close");
  const [spotlights, setSpotlights] = useState([]);
  const [editingSpotlight, setEditingSpotlight] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const getList = async (page = 1) => {
    const response = await getSpotlightsList(page, 10);
    setSpotlights(response.items || []);
    setTotalCount(response.total || 0);
    setCurrentPage(page);
  };

  useEffect(() => {
    getList(1);
  }, []);

  const columns = [
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "active",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span className={`badge ${value ? "badge-success" : "badge-danger"}`}>
            {value ? "Active" : "Inactive"}
          </span>
        ),
      },
    },
    {
      name: "created_at",
      label: "Created",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => formatDate("dd/MM/yyyy", new Date(value)),
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => (
          <div>
            <Tooltip title="Edit Organization" placement="top">
              <a
                id={`edit_school_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-primary"
                onClick={() => handleOpenModal("editing", value)}
              >
                <i className="fas fa-edit text-primary" />
              </a>
            </Tooltip>
            <Tooltip title="Delete Spotlight" placement="top">
              <a
                id={`delete_spotlight_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-danger text-danger mx-3"
                onClick={() => handleDeleteSpotlight(value)}
              >
                <Delete />
              </a>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const options = {
    serverSide: true,
    rowsPerPageOptions: [],
    rowsPerPage: 10,
    page: currentPage,
    count: totalCount,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    selectableRows: "none",
    tableBodyMaxHeight: isDesktop ? "50em" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows:",
        displayRows: "of",
      },
    },
    customFooter: (count, page, rowsPerPage) => (
      <CustomTableFooter
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={(mPage) => {
          settingLoader(true);
          getList(mPage)
            .catch(() => {})
            .finally(() => settingLoader(false));
        }}
      />
    ),
  };

  const handleOpenModal = async (mode, id = null) => {
    switch (mode) {
      case "create":
        settingLoader(true);
        setEditingSpotlight(null);
        setDialog(mode);
        break;
      case "editing":
        settingLoader(true);
        try {
          const spotlightData = await getSpotlight(id);
          setEditingSpotlight(spotlightData.spotlight);
          setDialog(mode);
        } catch (error) {
          console.error("Error loading spotlight:", error);
          settingLoader(false);
        }
        break;
      case "close":
        setDialog(mode);
        setEditingSpotlight(null);
        break;
      default:
        console.error("Invalid dialog mode");
    }
  };

  const handleDeleteSpotlight = (id) => {
    handleAlert({
      title: "Delete Spotlight",
      message: "Are you sure to permanently delete this Spotlight?",
      btn_msg: "Delete Spotlight",
      action: () =>
        deleteSpotlight(id).then(() => {
          getList(currentPage);
        }),
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <div className="pb-4 d-flex justify-content-end align-items-end">
        <Button
          id="create_school_btn"
          variant="contained"
          color="secondary"
          onClick={() => handleOpenModal("create")}
        >
          <Add /> Create Spotlight
        </Button>
      </div>
      <Paper>
        <MuiThemeProvider theme={actionTableMuiTheme()}>
          <MUIDataTable
            // title="Admin"
            columns={columns}
            data={spotlights}
            options={options}
          />
        </MuiThemeProvider>
      </Paper>
      <SpotlightDialog
        mode={dialog}
        setDialog={handleOpenModal}
        spotlight={editingSpotlight}
        onRefresh={getList}
      />
    </div>
  );
};

const mapStateToProps = (store) => ({
  schools: store.school.schools,
});

const mapDispatchToProps = (dispatch) => ({
  schoolActions: bindActionCreators(schoolDUCK.actions, dispatch),
  settingLoader: bindActionCreators(setLoader, dispatch),
  setAlertModal: bindActionCreators(setAlert, dispatch),
  handleAlert: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Spotlight);
